import request from '../utils/request';
import qs from "qs";

export function getDeviceList(param) {
    return request({
        url: '/admin/search-device',
        method: 'GET',
        params: param
    })
}

export function deleteDevice(id) {
    return request({
        url: '/admin/device/' + id,
        method: 'DELETE'
    })
}

export function setDeviceIsvalidate(id, isValidate) {
    return request({
        url: '/admin/device/' + id + "/is-validate/" + isValidate,
        method: 'PUT'
    })
}

export function getDeviceFrom() {
    return request({
        url: '/admin/device-from',
        method: 'GET',
    })
}

export function getDeviceType() {
    return request({
        url: '/admin/device-type',
        method: 'GET',
    })
}

export function saveTYDevice(data) {
    if(data.id === 0){
        return request({
            url: '/admin/device',
            method: 'POST',
            data
        })
    }
    return request({
        url: '/admin/device/'+data.id,
        method: 'PUT',
        data
    })
}

export function controlDevice(data) {
    return request({
        url: '/admin/device/'+data.id+'/control',
        method: 'PUT',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({"value":data.value})
    })
}
export function getAirList(param) {
    return request({
        url: '/admin/device/air-list',
        method: 'GET',
        params:param
    })
}

export function getConnList(param) {
    return request({
        url: '/admin/search-device-conn',
        method: 'GET',
        params:param
    })
}

export function setDeviceIsOnline(id,isOnline){
    return request({
        url:'/admin/device-conn/'+id+'/is-online/'+isOnline,
        method:'PUT'
    })
}

export function addDeviceConnect(data) {
        return request({
            url: '/admin/device-conn',
            method: 'POST',
            data
        })
}

export function deleteConnect(id) {
    return request({
        url: '/admin/device-conn/' + id,
        method: 'DELETE'
    })
}


export function getDeviceConn(params) {
    return request({
        url: '/admin/getDeviceConnLog',
        method: 'GET',
        params
    })
}

export function getDeviceOperation(params) {
    return request({
        url: '/admin/getDeviceOperationLog',
        method: 'GET',
        params
    })
}